import LoginPageContent from "@/app/login/page";

export default function LoginPage() {
  return <LoginPageContent />;
}
